import { Component, Input, OnInit } from '@angular/core';

import { getItemElementId } from '®shared/focus';

import { ResourceImageUtils } from './resource-image-utils';

@Component({
  selector: 'rl-list-item-placeholder',
  templateUrl: './list-item-placeholder.component.html',
})
export class ListItemPlaceholderComponent implements OnInit {
  @Input() itemId: string;
  itemElementId: string;

  resourceImage: string = ResourceImageUtils.placeholdersUrl('Loading');

  ngOnInit() {
    this.itemElementId = getItemElementId(this.itemId);
  }
}
